import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function RFCValidator(isComercial: boolean, allowBoth = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regexMoral = new RegExp(/^[A-ZÑ&]{3}\d{6}[A-Z0-9]{3}$/i);
    const regexFisica = new RegExp(/^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/i);
    let result = null;
    if (allowBoth) {
      result = regexMoral.test(control.value) || regexFisica.test(control.value);
    } else {
      const regex: RegExp = isComercial ? regexMoral : regexFisica;
      result = regex.test(control.value);
    }

    return (result || control.value === '') ? null : {rfcInvalid: true};
    
  };
}